import { topMenuItemClassName } from "@components/HomePage/TopMenu/const";
import UiLanguage from "@ext/localization/core/model/UiLanguage";
import { IconButton } from "@ui-kit/Button";
import {
	DropdownMenu,
	DropdownMenuContent,
	DropdownMenuGroup,
	DropdownMenuItem,
	DropdownMenuTrigger,
} from "@ui-kit/Dropdown";
import { MenuItemInfoTemplate } from "@ui-kit/MenuItem";
import { Tooltip, TooltipContent, TooltipTrigger } from "@ui-kit/Tooltip";

interface SwitchUiLanguageMenuProps {
	current: UiLanguage;
	onChange: (language: UiLanguage) => void;
	getLabel: (language: UiLanguage) => string;
	tooltip: string;
	size?: "md" | "lg";
}

const SwitchUiLanguageMenu = ({ current, onChange, getLabel, tooltip, size = "md" }: SwitchUiLanguageMenuProps) => {
	return (
		<DropdownMenu>
			<Tooltip>
				<TooltipContent>{tooltip}</TooltipContent>
				<TooltipTrigger asChild>
					<DropdownMenuTrigger
						asChild
						className={topMenuItemClassName}
						data-qa={`qa-language-${current}`}
						data-testid="switch-ui-language"
					>
						<IconButton
							className="aspect-square p-2"
							icon="globe"
							iconClassName="h-5 w-5 stroke-[1.6]"
							size={size}
							variant="ghost"
						/>
					</DropdownMenuTrigger>
				</TooltipTrigger>
			</Tooltip>
			<DropdownMenuContent>
				<DropdownMenuGroup>
					{Object.values(UiLanguage).map((l) => (
						<DropdownMenuItem
							data-qa="qa-clickable"
							key={l}
							onClick={l === current ? null : () => onChange(l)}
						>
							<MenuItemInfoTemplate isSelected={current === l} text={getLabel(l)} />
						</DropdownMenuItem>
					))}
				</DropdownMenuGroup>
			</DropdownMenuContent>
		</DropdownMenu>
	);
};

export default SwitchUiLanguageMenu;
